import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import MuiCircularProgress from '@mui/material/CircularProgress';

import {
  charcoalGrey,
  dustyOrangeTwo,
  dustyOrangeTwoHover,
  fontWeight,
  lightGrey,
  pinkishOrange,
  veryLightGrey,
} from '~/styles';

export const CircularProgress = styled(MuiCircularProgress, {
  shouldForwardProp: prop => isPropValid(prop) && !['spinnerColor'].includes(prop),
})<{ spinnerColor?: string }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  color: ${({ spinnerColor }) => (spinnerColor ? spinnerColor : pinkishOrange)};
  opacity: 1;
`;

export const commonButtonStyles = `
  position: relative;
  color: #fff;
  border-radius: 4px;
  height: 50px;
  font-size: 14px;
  font-weight: ${fontWeight.semiBold};
  line-height: 17px;
  letter-spacing: 0.1em;
  cursor: pointer;
  text-transform: uppercase;
  margin: 0;
  display: inline-flex;
  vertical-align: middle;
  text-align: center;
  padding: 2px 30px 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: 2px solid transparent;
  transition: background-color 0.25s ease-in-out;
  &:hover {
    text-decoration: none;
  }
`;

export const buttonWidthoutBordersStyles = `
  cursor: pointer;
  font-size: 11px;
  letter-spacing: 2px;
  font-weight: 500;
  text-transform: uppercase;
  border: none;
  background: transparent;
  color: ${charcoalGrey};
  &:hover {
    text-decoration: underline;
  }
`;

export const disabledButtonStyles = `
&:disabled,&[ disabled ]{
      -webkit-transition: background-color 0.5s ease-out;
      -moz-transition: background-color 0.5s ease-out;
      -o-transition: background-color 0.5s ease-out;
      transition: background-color 0.5s ease-out;
      background-color: ${veryLightGrey};
      color: ${lightGrey};
      &:hover,
      &:focus {
        cursor: not-allowed;
        background-color: ${veryLightGrey};
      }
}
`;

export const orangeButtonStyles = `
  ${commonButtonStyles}
  ${disabledButtonStyles}
  background-color: ${dustyOrangeTwo};
    &:hover,
    &:focus {
        color: #fff;
        background-color: ${dustyOrangeTwoHover};
    }
`;

export const whiteOutlineButtonStyles = `
    ${commonButtonStyles}
    border: 2px solid #FFFFFF;
    &:hover,
    &:focus {
      color: #fff;
      background-color: #ffffff1f;
    }
`;
